import R from 'ramda';

function getAttorneyStatus(profile, invites) {
  const attorneys = R.filter(
    (invite) => invite.type === 'other' || invite.type === 'attorney',
    invites
  );
  const isAttorney =
    R.findIndex((attorney) => attorney.invitee === profile.id, attorneys) !==
    -1;
  return isAttorney;
}

export default getAttorneyStatus;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/helpers/getAttorneyStatus.js